// extracted by mini-css-extract-plugin
module.exports = {"root":"column_root__7VV5e"};